import { useWatch } from "react-hook-form";
import { type Translationtype } from "utils";
import { Tooltip } from "../components/tooltip";

interface IFormRadioButtonProps {
  register: any;
  errors: any;
  className?: string;
  disabled?: boolean;
  name: string;
  title: string;
  value: string | boolean;
  tooltip?: string;
  t: Translationtype;
  extraTitle?: string;
  checked?: boolean;
  control: any;
}

export function FormRadioButton({
  register,
  errors,
  className,
  disabled,
  name,
  title,
  tooltip,
  value,
  checked,
  extraTitle,
  control,
  t,
}: IFormRadioButtonProps) {
  const selectedValue = useWatch({ control, name });
  return (
    <div className={`${className || ""} w-full`}>
      <label
        htmlFor={title}
        className={`label cursor-pointer w-full ${
          selectedValue === value ? "bg-gray-100" : ""
        } w-full rounded-lg px-4 py-2 h-fit hover:bg-gray-100 cursor-pointer overflow-hidden`}
      >
        <div className="flex items-center gap-3 w-full">
          <input
            id={title}
            type="radio"
            className="radio checked:bg-brownDarker"
            disabled={disabled || false}
            value={value}
            defaultChecked={checked}
            {...register(name)}
          />
          <span className="label-text text-textColor ml-5">
            {title} {tooltip ? <Tooltip text={tooltip} /> : null}
          </span>
        </div>
        {extraTitle ? (
          <span className="whitespace-nowrap inline-flex items-center rounded-md bg-gray-200 px-2 h-8 font-semibold ring-1 ring-gray-500/10 ring-inset">
            {extraTitle}
          </span>
        ) : null}
      </label>
      {errors[`${name}`]?.message ? (
        <p className="text-sm my-3 text-error">
          {t(`${errors[`${name}`]?.message}` as any)}
        </p>
      ) : null}
    </div>
  );
}
